/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { SaleRangeType } from "components/management/user/incentiveManagement/incentive.interface.js";
import { IEditableTable, ITakafulBazaarUser } from "components/management/user/information/information.interface";
import { RootState } from "redux/store";

const initialState: {
  takafulBazaarUser: ITakafulBazaarUser;
  individualDurationSaleRanges: IEditableTable[];
  teamLeadDurationSaleRanges: IEditableTable[];
} = {
  takafulBazaarUser: {
    id: undefined,
    name: "",
    email: "",
    contactNumber: "",
    lineOfBusiness: [],
    role: [1]
  },
  individualDurationSaleRanges: [
    {
      key: 0,
      minTargetRange: 0,
      maxTargetRange: 0,
      factoring: 0,
      incentive: 0,
      minTargetRangeValueTypeId: 0,
      maxTargetRangeValueTypeId: 0,
      agentGrossCommission: "",
      preTaxCommission: "",
      withholdingTax: "",
      postTaxCommission: ""
    }
  ],
  teamLeadDurationSaleRanges: [
    {
      key: 0,
      minTargetRange: 0,
      maxTargetRange: 0,
      factoring: 0,
      incentive: 0,
      minTargetRangeValueTypeId: 0,
      maxTargetRangeValueTypeId: 0,
      agentGrossCommission: "",
      preTaxCommission: "",
      withholdingTax: "",
      postTaxCommission: ""
    }
  ]
};

const TakafulBazaarUserManagement = createSlice({
  name: "takafulBazaarUser",
  initialState,
  reducers: {
    AddTakafulBazaarUser: (state, action) => {
      state.takafulBazaarUser = action.payload;
    },
    DeleteTakafulBazaarUser: state => {
      state.takafulBazaarUser = initialState.takafulBazaarUser;
    },
    UpdateEditableTable: (state, action) => {
      state[action.payload.key as SaleRangeType] = action.payload.value;
    },
    addNewRowInEditableTable: (state, action) => {
      state[action.payload.key as SaleRangeType].push({
        ...initialState[action.payload.key as SaleRangeType][0],
        key: state[action.payload.key as SaleRangeType].length
      });
    },
    setTableToInitial: state => {
      state.individualDurationSaleRanges = initialState.individualDurationSaleRanges;
      state.teamLeadDurationSaleRanges = initialState.teamLeadDurationSaleRanges;
    },
    deleteTableRow: (state, action) => {
      state[action.payload.key as SaleRangeType] = state[action.payload.key as SaleRangeType].filter(val => val.key !== action.payload.deletedKey);
    }
  }
});

export const { AddTakafulBazaarUser, DeleteTakafulBazaarUser, UpdateEditableTable, addNewRowInEditableTable, setTableToInitial, deleteTableRow } =
  TakafulBazaarUserManagement.actions;
export default TakafulBazaarUserManagement.reducer;

export const getTakafulBazaarUser = (state: RootState) => state.takafulBazaarUser;
